export default __webpack_public_path__ + "static/media/product-detail-full-03.5a8e7ea9.jpg";